import { EventEmitter, Injectable, ɵɵdefineInjectable, Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, NgZone, Output, HostListener, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function ToastifyToastContainerComponent_lib_toastify_toast_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-toastify-toast", 1);
    ɵngcc0.ɵɵlistener("dismissEvent", function ToastifyToastContainerComponent_lib_toastify_toast_1_Template_lib_toastify_toast_dismissEvent_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const toast_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.dismiss(toast_r1); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toast_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.getClass(toast_r1));
    ɵngcc0.ɵɵproperty("autoClose", ctx_r0.autoClose)("toast", toast_r1)("hideProgressBar", ctx_r0.hideProgressBar)("pauseOnHover", ctx_r0.pauseOnHover)("pauseOnVisibilityChange", ctx_r0.pauseOnVisibilityChange)("closeOnClick", ctx_r0.closeOnClick)("iconLibrary", ctx_r0.iconLibrary);
} }
function ToastifyToastComponent_span_2_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵtext(1, "info_outline");
    ɵngcc0.ɵɵelementEnd();
} }
function ToastifyToastComponent_span_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵtext(1, "info_outline");
    ɵngcc0.ɵɵelementEnd();
} }
function ToastifyToastComponent_span_2_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵtext(1, "warning_outline");
    ɵngcc0.ɵɵelementEnd();
} }
function ToastifyToastComponent_span_2_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵtext(1, "error_outline");
    ɵngcc0.ɵɵelementEnd();
} }
function ToastifyToastComponent_span_2_i_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵtext(1, "done");
    ɵngcc0.ɵɵelementEnd();
} }
function ToastifyToastComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtemplate(1, ToastifyToastComponent_span_2_i_1_Template, 2, 0, "i", 7);
    ɵngcc0.ɵɵtemplate(2, ToastifyToastComponent_span_2_i_2_Template, 2, 0, "i", 7);
    ɵngcc0.ɵɵtemplate(3, ToastifyToastComponent_span_2_i_3_Template, 2, 0, "i", 7);
    ɵngcc0.ɵɵtemplate(4, ToastifyToastComponent_span_2_i_4_Template, 2, 0, "i", 7);
    ɵngcc0.ɵɵtemplate(5, ToastifyToastComponent_span_2_i_5_Template, 2, 0, "i", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r0.toast.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.ToastType.info);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.ToastType.default);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.ToastType.warning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.ToastType.error);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.ToastType.success);
} }
function ToastifyToastComponent_span_3_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} }
function ToastifyToastComponent_span_3_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} }
function ToastifyToastComponent_span_3_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
function ToastifyToastComponent_span_3_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 15);
} }
function ToastifyToastComponent_span_3_i_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 16);
} }
function ToastifyToastComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtemplate(1, ToastifyToastComponent_span_3_i_1_Template, 1, 0, "i", 9);
    ɵngcc0.ɵɵtemplate(2, ToastifyToastComponent_span_3_i_2_Template, 1, 0, "i", 9);
    ɵngcc0.ɵɵtemplate(3, ToastifyToastComponent_span_3_i_3_Template, 1, 0, "i", 10);
    ɵngcc0.ɵɵtemplate(4, ToastifyToastComponent_span_3_i_4_Template, 1, 0, "i", 11);
    ɵngcc0.ɵɵtemplate(5, ToastifyToastComponent_span_3_i_5_Template, 1, 0, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r1.toast.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.ToastType.info);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.ToastType.default);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.ToastType.warning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.ToastType.error);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r1.ToastType.success);
} }
function ToastifyToastComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("progress-bar progress-bar--", ctx_r2.ToastType[ctx_r2.toast.type], "");
    ɵngcc0.ɵɵstyleProp("animation-play-state", ctx_r2.running ? "running" : "paused")("animation-duration", ctx_r2.autoClose + "ms");
} }
let toastIdentitySequence = 0;
class Toast {
    /**
     * @param {?} message
     * @param {?} type
     */
    constructor(message, type) {
        this.message = message;
        this.type = type;
        this.time = new Date().getTime();
        this.id = toastIdentitySequence++;
    }
}
if (false) {
    /** @type {?} */
    Toast.prototype.id;
    /** @type {?} */
    Toast.prototype.message;
    /** @type {?} */
    Toast.prototype.type;
    /** @type {?} */
    Toast.prototype.time;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast-type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const ToastType = {
    info: 0,
    success: 1,
    warning: 2,
    error: 3,
    default: 4,
};
ToastType[ToastType.info] = 'info';
ToastType[ToastType.success] = 'success';
ToastType[ToastType.warning] = 'warning';
ToastType[ToastType.error] = 'error';
ToastType[ToastType.default] = 'default';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastService {
    constructor() {
        this.toastAddedEvent = new EventEmitter();
        this.dismissAllEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    dismissAll() {
        this.dismissAllEvent.emit();
    }
    /**
     * @param {?} message
     * @return {?}
     */
    info(message) {
        /** @type {?} */
        const toast = new Toast(message, ToastType.info);
        this.toastAddedEvent.emit(toast);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    success(message) {
        /** @type {?} */
        const toast = new Toast(message, ToastType.success);
        this.toastAddedEvent.emit(toast);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    warn(message) {
        /** @type {?} */
        const toast = new Toast(message, ToastType.warning);
        this.toastAddedEvent.emit(toast);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    error(message) {
        /** @type {?} */
        const toast = new Toast(message, ToastType.error);
        this.toastAddedEvent.emit(toast);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    default(message) {
        /** @type {?} */
        const toast = new Toast(message, ToastType.default);
        this.toastAddedEvent.emit(toast);
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(); };
/** @nocollapse */
ToastService.ctorParameters = () => [];
/** @nocollapse */ ToastService.ɵprov = ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(); }, token: ToastService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    ToastService.prototype.toastAddedEvent;
    /** @type {?} */
    ToastService.prototype.dismissAllEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toastify-toast-container/toastify-toast-container.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastifyToastContainerComponent {
    /**
     * @param {?} _toastService
     * @param {?} _cd
     */
    constructor(_toastService, _cd) {
        this._toastService = _toastService;
        this._cd = _cd;
        this.transitionDurations = 400;
        this.position = 'top-right';
        this.transition = 'bounce';
        this.autoClose = 5000;
        this.hideProgressBar = false;
        this.pauseOnHover = true;
        this.pauseOnVisibilityChange = true;
        this.closeOnClick = true;
        this.newestOnTop = false;
        this.iconLibrary = 'none';
        this.ToastType = ToastType;
        this.toasts = new Array();
        this.toastTransitionDict = {};
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        this._cd.markForCheck();
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    dismiss(toast) {
        this.toastTransitionDict[toast.id] = TransitionState.exiting;
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const index = this.toasts.indexOf(toast);
            this.toasts.splice(index, 1);
            this._cd.markForCheck();
        }), this.transitionDurations);
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    getClass(toast) {
        /** @type {?} */
        let base = `toast toast--${ToastType[toast.type]} `;
        /** @type {?} */
        const state = this.toastTransitionDict[toast.id];
        if (state === TransitionState.entering) {
            base += `${this.transition}-enter ${this.transition}-enter--${this.position}`;
        }
        else if (state === TransitionState.exiting) {
            base += `${this.transition}-exit ${this.transition}-exit--${this.position}`;
        }
        return base;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._toastService.dismissAllEvent.subscribe((/**
         * @return {?}
         */
        () => {
            this.toasts = new Array();
            this._cd.markForCheck();
        }));
        this._toastService.toastAddedEvent.subscribe((/**
         * @param {?} toast
         * @return {?}
         */
        toast => {
            this.toastTransitionDict[toast.id] = TransitionState.entering;
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.toastTransitionDict[toast.id] = TransitionState.noTransition;
                this._cd.markForCheck();
            }), this.transitionDurations);
            if (this.newestOnTop) {
                this.toasts.unshift(toast);
            }
            else {
                this.toasts.push(toast);
            }
            this._cd.markForCheck();
        }));
    }
}
ToastifyToastContainerComponent.ɵfac = function ToastifyToastContainerComponent_Factory(t) { return new (t || ToastifyToastContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ToastService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ToastifyToastContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToastifyToastContainerComponent, selectors: [["lib-toastify-toast-container"]], inputs: { position: "position", transition: "transition", autoClose: "autoClose", hideProgressBar: "hideProgressBar", pauseOnHover: "pauseOnHover", pauseOnVisibilityChange: "pauseOnVisibilityChange", closeOnClick: "closeOnClick", newestOnTop: "newestOnTop", iconLibrary: "iconLibrary" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 4, consts: [["style", "animation-fill-mode: both; animation-duration: 0.75s", 3, "class", "autoClose", "toast", "hideProgressBar", "pauseOnHover", "pauseOnVisibilityChange", "closeOnClick", "iconLibrary", "dismissEvent", 4, "ngFor", "ngForOf"], [2, "animation-fill-mode", "both", "animation-duration", "0.75s", 3, "autoClose", "toast", "hideProgressBar", "pauseOnHover", "pauseOnVisibilityChange", "closeOnClick", "iconLibrary", "dismissEvent"]], template: function ToastifyToastContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, ToastifyToastContainerComponent_lib_toastify_toast_1_Template, 1, 9, "lib-toastify-toast", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("toast-container toast-container--", ctx.position, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.toasts);
    } }, directives: function () { return [ɵngcc1.NgForOf, ToastifyToastComponent]; }, styles: [".toast-container[_ngcontent-%COMP%]{-webkit-transform:translateZ(9999px);box-sizing:border-box;color:#fff;padding:4px;position:fixed;width:320px;z-index:9999}.toast-container--top-left[_ngcontent-%COMP%]{left:1em;top:1em}.toast-container--top-center[_ngcontent-%COMP%]{left:50%;margin-left:-160px;top:1em}.toast-container--top-right[_ngcontent-%COMP%]{right:1em;top:1em}.toast-container--bottom-left[_ngcontent-%COMP%]{bottom:1em;left:1em}.toast-container--bottom-center[_ngcontent-%COMP%]{bottom:1em;left:50%;margin-left:-160px}.toast-container--bottom-right[_ngcontent-%COMP%]{bottom:1em;right:1em}@media only screen and (max-width:480px){.toast-container[_ngcontent-%COMP%]{left:0;margin:0;padding:0;width:100vw}.toast-container--top-center[_ngcontent-%COMP%], .toast-container--top-left[_ngcontent-%COMP%], .toast-container--top-right[_ngcontent-%COMP%]{top:0}.toast-container--bottom-center[_ngcontent-%COMP%], .toast-container--bottom-left[_ngcontent-%COMP%], .toast-container--bottom-right[_ngcontent-%COMP%]{bottom:0}.toast-container--rtl[_ngcontent-%COMP%]{left:auto;right:0}}.toast[_ngcontent-%COMP%]{border-radius:1px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);box-sizing:border-box;cursor:pointer;direction:ltr;display:flex;font-family:sans-serif;justify-content:space-between;margin-bottom:1rem;max-height:800px;min-height:64px;overflow:hidden;padding:8px;position:relative}.toast--rtl[_ngcontent-%COMP%]{direction:rtl}.toast--default[_ngcontent-%COMP%]{background:#fff;color:#aaa}.toast--info[_ngcontent-%COMP%]{background:#3498db}.toast--success[_ngcontent-%COMP%]{background:#07bc0c}.toast--warning[_ngcontent-%COMP%]{background:#f1c40f}.toast--error[_ngcontent-%COMP%]{background:#e74c3c}.toast-body[_ngcontent-%COMP%]{flex:1;margin:auto 0}@media only screen and (max-width:480px){.toast[_ngcontent-%COMP%]{margin-bottom:0}}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@-webkit-keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@-webkit-keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@-webkit-keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@-webkit-keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounce-enter--bottom-left[_ngcontent-%COMP%], .bounce-enter--top-left[_ngcontent-%COMP%]{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}.bounce-enter--bottom-right[_ngcontent-%COMP%], .bounce-enter--top-right[_ngcontent-%COMP%]{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}.bounce-enter--top-center[_ngcontent-%COMP%]{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}.bounce-enter--bottom-center[_ngcontent-%COMP%]{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}.bounce-exit--bottom-left[_ngcontent-%COMP%], .bounce-exit--top-left[_ngcontent-%COMP%]{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}.bounce-exit--bottom-right[_ngcontent-%COMP%], .bounce-exit--top-right[_ngcontent-%COMP%]{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}.bounce-exit--top-center[_ngcontent-%COMP%]{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}.bounce-exit--bottom-center[_ngcontent-%COMP%]{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@-webkit-keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoom-enter[_ngcontent-%COMP%]{-webkit-animation-name:zoomIn;animation-name:zoomIn}.zoom-exit[_ngcontent-%COMP%]{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes flipIn{0%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateX(90deg)}40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;transform:perspective(400px) rotateX(-20deg)}60%{opacity:1;transform:perspective(400px) rotateX(10deg)}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes flipIn{0%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateX(90deg)}40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;transform:perspective(400px) rotateX(-20deg)}60%{opacity:1;transform:perspective(400px) rotateX(10deg)}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@-webkit-keyframes flipOut{0%{transform:perspective(400px)}30%{opacity:1;transform:perspective(400px) rotateX(-20deg)}to{opacity:0;transform:perspective(400px) rotateX(90deg)}}@keyframes flipOut{0%{transform:perspective(400px)}30%{opacity:1;transform:perspective(400px) rotateX(-20deg)}to{opacity:0;transform:perspective(400px) rotateX(90deg)}}.flip-enter[_ngcontent-%COMP%]{-webkit-animation-name:flipIn;animation-name:flipIn}.flip-exit[_ngcontent-%COMP%]{-webkit-animation-name:flipOut;animation-name:flipOut}@-webkit-keyframes slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(110%,0,0);visibility:hidden}}@keyframes slideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(110%,0,0);visibility:hidden}}@-webkit-keyframes slideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-110%,0,0);visibility:hidden}}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-110%,0,0);visibility:hidden}}@-webkit-keyframes slideOutDown{0%{transform:translateZ(0)}to{transform:translate3d(0,500px,0);visibility:hidden}}@keyframes slideOutDown{0%{transform:translateZ(0)}to{transform:translate3d(0,500px,0);visibility:hidden}}@-webkit-keyframes slideOutUp{0%{transform:translateZ(0)}to{transform:translate3d(0,-500px,0);visibility:hidden}}@keyframes slideOutUp{0%{transform:translateZ(0)}to{transform:translate3d(0,-500px,0);visibility:hidden}}.slide-enter--bottom-left[_ngcontent-%COMP%], .slide-enter--top-left[_ngcontent-%COMP%]{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}.slide-enter--bottom-right[_ngcontent-%COMP%], .slide-enter--top-right[_ngcontent-%COMP%]{-webkit-animation-name:slideInRight;animation-name:slideInRight}.slide-enter--top-center[_ngcontent-%COMP%]{-webkit-animation-name:slideInDown;animation-name:slideInDown}.slide-enter--bottom-center[_ngcontent-%COMP%]{-webkit-animation-name:slideInUp;animation-name:slideInUp}.slide-exit--bottom-left[_ngcontent-%COMP%], .slide-exit--top-left[_ngcontent-%COMP%]{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}.slide-exit--bottom-right[_ngcontent-%COMP%], .slide-exit--top-right[_ngcontent-%COMP%]{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}.slide-exit--top-center[_ngcontent-%COMP%]{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}.slide-exit--bottom-center[_ngcontent-%COMP%]{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}"], changeDetection: 0 });
/** @nocollapse */
ToastifyToastContainerComponent.ctorParameters = () => [
    { type: ToastService },
    { type: ChangeDetectorRef }
];
ToastifyToastContainerComponent.propDecorators = {
    position: [{ type: Input }],
    transition: [{ type: Input }],
    autoClose: [{ type: Input }],
    hideProgressBar: [{ type: Input }],
    pauseOnHover: [{ type: Input }],
    pauseOnVisibilityChange: [{ type: Input }],
    closeOnClick: [{ type: Input }],
    newestOnTop: [{ type: Input }],
    iconLibrary: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastifyToastContainerComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'lib-toastify-toast-container',
                template: "<div class=\"toast-container toast-container--{{position}}\">\n    <lib-toastify-toast *ngFor=\"let toast of toasts\" [class]=\"getClass(toast)\" style=\"animation-fill-mode: both; animation-duration: 0.75s\"\n        [autoClose]=\"autoClose\" [toast]=\"toast\" (dismissEvent)=\"dismiss(toast)\" [hideProgressBar]=\"hideProgressBar\" [pauseOnHover]=\"pauseOnHover\"\n        [pauseOnVisibilityChange]=\"pauseOnVisibilityChange\" [closeOnClick]=\"closeOnClick\" [iconLibrary]=\"iconLibrary\">\n    </lib-toastify-toast>\n</div>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".toast-container{-webkit-transform:translateZ(9999px);box-sizing:border-box;color:#fff;padding:4px;position:fixed;width:320px;z-index:9999}.toast-container--top-left{left:1em;top:1em}.toast-container--top-center{left:50%;margin-left:-160px;top:1em}.toast-container--top-right{right:1em;top:1em}.toast-container--bottom-left{bottom:1em;left:1em}.toast-container--bottom-center{bottom:1em;left:50%;margin-left:-160px}.toast-container--bottom-right{bottom:1em;right:1em}@media only screen and (max-width:480px){.toast-container{left:0;margin:0;padding:0;width:100vw}.toast-container--top-center,.toast-container--top-left,.toast-container--top-right{top:0}.toast-container--bottom-center,.toast-container--bottom-left,.toast-container--bottom-right{bottom:0}.toast-container--rtl{left:auto;right:0}}.toast{border-radius:1px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);box-sizing:border-box;cursor:pointer;direction:ltr;display:flex;font-family:sans-serif;justify-content:space-between;margin-bottom:1rem;max-height:800px;min-height:64px;overflow:hidden;padding:8px;position:relative}.toast--rtl{direction:rtl}.toast--default{background:#fff;color:#aaa}.toast--info{background:#3498db}.toast--success{background:#07bc0c}.toast--warning{background:#f1c40f}.toast--error{background:#e74c3c}.toast-body{flex:1;margin:auto 0}@media only screen and (max-width:480px){.toast{margin-bottom:0}}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@-webkit-keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@-webkit-keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@-webkit-keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@-webkit-keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounce-enter--bottom-left,.bounce-enter--top-left{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}.bounce-enter--bottom-right,.bounce-enter--top-right{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}.bounce-enter--top-center{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}.bounce-enter--bottom-center{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}.bounce-exit--bottom-left,.bounce-exit--top-left{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}.bounce-exit--bottom-right,.bounce-exit--top-right{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}.bounce-exit--top-center{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}.bounce-exit--bottom-center{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@-webkit-keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoom-enter{-webkit-animation-name:zoomIn;animation-name:zoomIn}.zoom-exit{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes flipIn{0%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateX(90deg)}40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;transform:perspective(400px) rotateX(-20deg)}60%{opacity:1;transform:perspective(400px) rotateX(10deg)}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes flipIn{0%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateX(90deg)}40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;transform:perspective(400px) rotateX(-20deg)}60%{opacity:1;transform:perspective(400px) rotateX(10deg)}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@-webkit-keyframes flipOut{0%{transform:perspective(400px)}30%{opacity:1;transform:perspective(400px) rotateX(-20deg)}to{opacity:0;transform:perspective(400px) rotateX(90deg)}}@keyframes flipOut{0%{transform:perspective(400px)}30%{opacity:1;transform:perspective(400px) rotateX(-20deg)}to{opacity:0;transform:perspective(400px) rotateX(90deg)}}.flip-enter{-webkit-animation-name:flipIn;animation-name:flipIn}.flip-exit{-webkit-animation-name:flipOut;animation-name:flipOut}@-webkit-keyframes slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@-webkit-keyframes slideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(110%,0,0);visibility:hidden}}@keyframes slideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(110%,0,0);visibility:hidden}}@-webkit-keyframes slideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-110%,0,0);visibility:hidden}}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-110%,0,0);visibility:hidden}}@-webkit-keyframes slideOutDown{0%{transform:translateZ(0)}to{transform:translate3d(0,500px,0);visibility:hidden}}@keyframes slideOutDown{0%{transform:translateZ(0)}to{transform:translate3d(0,500px,0);visibility:hidden}}@-webkit-keyframes slideOutUp{0%{transform:translateZ(0)}to{transform:translate3d(0,-500px,0);visibility:hidden}}@keyframes slideOutUp{0%{transform:translateZ(0)}to{transform:translate3d(0,-500px,0);visibility:hidden}}.slide-enter--bottom-left,.slide-enter--top-left{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}.slide-enter--bottom-right,.slide-enter--top-right{-webkit-animation-name:slideInRight;animation-name:slideInRight}.slide-enter--top-center{-webkit-animation-name:slideInDown;animation-name:slideInDown}.slide-enter--bottom-center{-webkit-animation-name:slideInUp;animation-name:slideInUp}.slide-exit--bottom-left,.slide-exit--top-left{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}.slide-exit--bottom-right,.slide-exit--top-right{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}.slide-exit--top-center{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}.slide-exit--bottom-center{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}"]
            }]
    }], function () { return [{ type: ToastService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { position: [{
            type: Input
        }], transition: [{
            type: Input
        }], autoClose: [{
            type: Input
        }], hideProgressBar: [{
            type: Input
        }], pauseOnHover: [{
            type: Input
        }], pauseOnVisibilityChange: [{
            type: Input
        }], closeOnClick: [{
            type: Input
        }], newestOnTop: [{
            type: Input
        }], iconLibrary: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ToastifyToastContainerComponent.prototype.transitionDurations;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.position;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.transition;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.autoClose;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.hideProgressBar;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.pauseOnHover;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.pauseOnVisibilityChange;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.closeOnClick;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.newestOnTop;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.iconLibrary;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.ToastType;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.toasts;
    /** @type {?} */
    ToastifyToastContainerComponent.prototype.toastTransitionDict;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastContainerComponent.prototype._toastService;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastContainerComponent.prototype._cd;
}
/** @enum {number} */
const TransitionState = {
    entering: 0,
    noTransition: 1,
    exiting: 2,
};
TransitionState[TransitionState.entering] = 'entering';
TransitionState[TransitionState.noTransition] = 'noTransition';
TransitionState[TransitionState.exiting] = 'exiting';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toastify-toast/toastify-toast.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastifyToastComponent {
    /**
     * @param {?} _cd
     * @param {?} _zone
     */
    constructor(_cd, _zone) {
        this._cd = _cd;
        this._zone = _zone;
        this.autoClose = 5000;
        this.hideProgressBar = false;
        this.pauseOnHover = true;
        this.pauseOnVisibilityChange = true;
        this.closeOnClick = true;
        this.dismissEvent = new EventEmitter();
        this.ToastType = ToastType;
        this.running = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.autoCloseRemaining = this.autoClose;
        this.startTime = this.toast.time;
        // Do not start timer when toast is prompted while window is out of focus
        if (this.handleVisibilityChange && document.visibilityState === 'visible') {
            this.startCloseTimer();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.clearTimerTimeout();
    }
    /**
     * @return {?}
     */
    startCloseTimer() {
        if (this.running || !this.autoClose) {
            return;
        }
        this.startTime = new Date().getTime();
        this.running = true;
        this.autoDismissTimeout = this._zone.runOutsideAngular((/**
         * @return {?}
         */
        () => setTimeout((/**
         * @return {?}
         */
        () => {
            this._zone.run((/**
             * @return {?}
             */
            () => {
                this.dismissEvent.emit();
                this._cd.markForCheck();
            }));
        }), this.autoCloseRemaining)));
    }
    /**
     * @return {?}
     */
    pauseCloseTimer() {
        this.running = false;
        this.clearTimerTimeout();
        // Calculate the elapsed time, subtract remaining time
        this.pauseTime = new Date().getTime();
        /** @type {?} */
        const elapsed = this.pauseTime - this.startTime;
        this.autoCloseRemaining -= elapsed;
    }
    /**
     * @return {?}
     */
    clearTimerTimeout() {
        if (this.autoDismissTimeout !== undefined) {
            clearTimeout(this.autoDismissTimeout);
        }
    }
    /**
     * @return {?}
     */
    handleDismissButtonAction() {
        if (this.closeOnClick) {
            return; // Let the other event handle the dismissal
        }
        this.clearTimerTimeout();
        this.dismissEvent.emit();
    }
    /**
     * @return {?}
     */
    handleHostClick() {
        if (this.closeOnClick) {
            this.clearTimerTimeout();
            this.dismissEvent.emit();
        }
    }
    /**
     * @return {?}
     */
    handleMouseEnter() {
        if (this.pauseOnHover) {
            this.pauseCloseTimer();
        }
    }
    /**
     * @return {?}
     */
    handleMouseLeave() {
        if (this.pauseOnHover) {
            this.startCloseTimer();
        }
    }
    /**
     * @return {?}
     */
    handleVisibilityChange() {
        if (!this.pauseOnVisibilityChange) {
            return;
        }
        if (document.visibilityState !== 'visible') {
            this.pauseCloseTimer();
            this._cd.detectChanges();
        }
        else {
            this.startCloseTimer();
        }
    }
}
ToastifyToastComponent.ɵfac = function ToastifyToastComponent_Factory(t) { return new (t || ToastifyToastComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ToastifyToastComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToastifyToastComponent, selectors: [["lib-toastify-toast"]], hostBindings: function ToastifyToastComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ToastifyToastComponent_click_HostBindingHandler() { return ctx.handleHostClick(); })("mouseenter", function ToastifyToastComponent_mouseenter_HostBindingHandler() { return ctx.handleMouseEnter(); })("mouseleave", function ToastifyToastComponent_mouseleave_HostBindingHandler() { return ctx.handleMouseLeave(); })("visibilitychange", function ToastifyToastComponent_visibilitychange_HostBindingHandler() { return ctx.handleVisibilityChange(); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { autoClose: "autoClose", hideProgressBar: "hideProgressBar", pauseOnHover: "pauseOnHover", pauseOnVisibilityChange: "pauseOnVisibilityChange", closeOnClick: "closeOnClick", toast: "toast", iconLibrary: "iconLibrary" }, outputs: { dismissEvent: "dismissEvent" }, decls: 10, vars: 7, consts: [["role", "alert", 1, "toast-body"], [1, "icon-container"], [3, "ngSwitch", 4, "ngIf"], [1, "toast-container"], ["type", "button", "aria-label", "close", 3, "click"], ["style", "opacity: 1;", 3, "class", "animation-play-state", "animation-duration", 4, "ngIf"], [3, "ngSwitch"], ["class", "material-icons", 4, "ngSwitchCase"], [1, "material-icons"], ["class", "fa fa-info", 4, "ngSwitchCase"], ["class", "fa fa-exclamation-triangle", 4, "ngSwitchCase"], ["class", "fa fa-exclamation", 4, "ngSwitchCase"], ["class", "fa fa-check", 4, "ngSwitchCase"], [1, "fa", "fa-info"], [1, "fa", "fa-exclamation-triangle"], [1, "fa", "fa-exclamation"], [1, "fa", "fa-check"], [2, "opacity", "1"]], template: function ToastifyToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ToastifyToastComponent_span_2_Template, 6, 6, "span", 2);
        ɵngcc0.ɵɵtemplate(3, ToastifyToastComponent_span_3_Template, 6, 6, "span", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 4);
        ɵngcc0.ɵɵlistener("click", function ToastifyToastComponent_Template_button_click_7_listener() { return ctx.handleDismissButtonAction(); });
        ɵngcc0.ɵɵtext(8, "\u2716");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, ToastifyToastComponent_div_9_Template, 1, 7, "div", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLibrary == "material");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLibrary == "font-awesome");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.toast.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("close-button close-button--", ctx.ToastType[ctx.toast.type], "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideProgressBar);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase], styles: [".toast[_ngcontent-%COMP%]{border-radius:1px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);box-sizing:border-box;cursor:pointer;direction:ltr;display:flex;font-family:sans-serif;justify-content:space-between;margin-bottom:1rem;max-height:800px;min-height:64px;overflow:hidden;padding:8px;position:relative}.toast--rtl[_ngcontent-%COMP%]{direction:rtl}.toast--default[_ngcontent-%COMP%]{background:#fff;color:#aaa}.toast--info[_ngcontent-%COMP%]{background:#3498db}.toast--success[_ngcontent-%COMP%]{background:#07bc0c}.toast--warning[_ngcontent-%COMP%]{background:#f1c40f}.toast--error[_ngcontent-%COMP%]{background:#e74c3c}.toast-body[_ngcontent-%COMP%]{flex:1;margin:auto 0}@media only screen and (max-width:480px){.toast[_ngcontent-%COMP%]{margin-bottom:0}}.close-button[_ngcontent-%COMP%]{align-self:flex-start;background:transparent;border:none;color:#fff;cursor:pointer;font-size:14px;font-weight:700;opacity:.7;outline:none;padding:0;transition:.3s ease}.close-button--default[_ngcontent-%COMP%]{color:#000;opacity:.3}.close-button[_ngcontent-%COMP%]:focus, .close-button[_ngcontent-%COMP%]:hover{opacity:1}@-webkit-keyframes trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}@keyframes trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.progress-bar[_ngcontent-%COMP%]{background-color:hsla(0,0%,100%,.7);bottom:0;height:5px;left:0;opacity:.7;position:absolute;transform-origin:left;width:100%;z-index:9999}.progress-bar[_ngcontent-%COMP%], .progress-bar--animated[_ngcontent-%COMP%]{-webkit-animation:trackProgress linear 1 forwards;animation:trackProgress linear 1 forwards}.progress-bar--controlled[_ngcontent-%COMP%]{transition:transform .2s}.progress-bar--rtl[_ngcontent-%COMP%]{left:auto;right:0;transform-origin:right}.progress-bar--default[_ngcontent-%COMP%]{background:linear-gradient(90deg,#4cd964,#5ac8fa,#007aff,#34aadc,#5856d6,#ff2d55)}.icon-container[_ngcontent-%COMP%], .toast-body[_ngcontent-%COMP%]{vertical-align:middle}.icon-container[_ngcontent-%COMP%]{display:inline-block;width:25px}.icon-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;margin-right:.5rem;text-align:center;width:20px}.icon-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{vertical-align:middle}.fa[_ngcontent-%COMP%], .material-icons[_ngcontent-%COMP%]{font-size:18px}.toast-container[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;width:calc(100% - 25px)}"], changeDetection: 0 });
/** @nocollapse */
ToastifyToastComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: NgZone }
];
ToastifyToastComponent.propDecorators = {
    autoClose: [{ type: Input }],
    hideProgressBar: [{ type: Input }],
    pauseOnHover: [{ type: Input }],
    pauseOnVisibilityChange: [{ type: Input }],
    closeOnClick: [{ type: Input }],
    toast: [{ type: Input }],
    iconLibrary: [{ type: Input }],
    dismissEvent: [{ type: Output }],
    handleHostClick: [{ type: HostListener, args: ['click',] }],
    handleMouseEnter: [{ type: HostListener, args: ['mouseenter',] }],
    handleMouseLeave: [{ type: HostListener, args: ['mouseleave',] }],
    handleVisibilityChange: [{ type: HostListener, args: ['document:visibilitychange',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastifyToastComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'lib-toastify-toast',
                template: "<div role=\"alert\" class=\"toast-body\">\n    <div class=\"icon-container\">\n        <span *ngIf=\"iconLibrary == 'material'\" [ngSwitch]=\"toast.type\">\n            <i class=\"material-icons\" *ngSwitchCase=\"ToastType.info\">info_outline</i>\n            <i class=\"material-icons\" *ngSwitchCase=\"ToastType.default\">info_outline</i>\n            <i class=\"material-icons\" *ngSwitchCase=\"ToastType.warning\">warning_outline</i>\n            <i class=\"material-icons\" *ngSwitchCase=\"ToastType.error\">error_outline</i>\n            <i class=\"material-icons\" *ngSwitchCase=\"ToastType.success\">done</i>\n        </span>\n        <span *ngIf=\"iconLibrary == 'font-awesome'\" [ngSwitch]=\"toast.type\">\n            <i *ngSwitchCase=\"ToastType.info\" class=\"fa fa-info\"></i>\n            <i *ngSwitchCase=\"ToastType.default\" class=\"fa fa-info\"></i>\n            <i *ngSwitchCase=\"ToastType.warning\" class=\"fa fa-exclamation-triangle\"></i>\n            <i *ngSwitchCase=\"ToastType.error\" class=\"fa fa-exclamation\"></i>\n            <i *ngSwitchCase=\"ToastType.success\" class=\"fa fa-check\"></i>\n        </span>\n    </div>\n    <div class=\"toast-container\">\n        <span>{{toast.message}}</span>\n    </div>\n</div>\n<button (click)=\"handleDismissButtonAction()\" class=\"close-button close-button--{{ToastType[toast.type]}}\" type=\"button\" aria-label=\"close\">\u2716</button>\n<div *ngIf=\"!hideProgressBar\" class=\"progress-bar progress-bar--{{ToastType[toast.type]}}\"\n    [style.animation-play-state]=\"running? 'running' : 'paused'\" [style.animation-duration]=\"this.autoClose + 'ms'\" style=\"opacity: 1;\"></div>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".toast{border-radius:1px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);box-sizing:border-box;cursor:pointer;direction:ltr;display:flex;font-family:sans-serif;justify-content:space-between;margin-bottom:1rem;max-height:800px;min-height:64px;overflow:hidden;padding:8px;position:relative}.toast--rtl{direction:rtl}.toast--default{background:#fff;color:#aaa}.toast--info{background:#3498db}.toast--success{background:#07bc0c}.toast--warning{background:#f1c40f}.toast--error{background:#e74c3c}.toast-body{flex:1;margin:auto 0}@media only screen and (max-width:480px){.toast{margin-bottom:0}}.close-button{align-self:flex-start;background:transparent;border:none;color:#fff;cursor:pointer;font-size:14px;font-weight:700;opacity:.7;outline:none;padding:0;transition:.3s ease}.close-button--default{color:#000;opacity:.3}.close-button:focus,.close-button:hover{opacity:1}@-webkit-keyframes trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}@keyframes trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.progress-bar{background-color:hsla(0,0%,100%,.7);bottom:0;height:5px;left:0;opacity:.7;position:absolute;transform-origin:left;width:100%;z-index:9999}.progress-bar,.progress-bar--animated{-webkit-animation:trackProgress linear 1 forwards;animation:trackProgress linear 1 forwards}.progress-bar--controlled{transition:transform .2s}.progress-bar--rtl{left:auto;right:0;transform-origin:right}.progress-bar--default{background:linear-gradient(90deg,#4cd964,#5ac8fa,#007aff,#34aadc,#5856d6,#ff2d55)}.icon-container,.toast-body{vertical-align:middle}.icon-container{display:inline-block;width:25px}.icon-container span{display:inline-block;margin-right:.5rem;text-align:center;width:20px}.icon-container span i{vertical-align:middle}.fa,.material-icons{font-size:18px}.toast-container{display:inline-block;vertical-align:middle;width:calc(100% - 25px)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { autoClose: [{
            type: Input
        }], hideProgressBar: [{
            type: Input
        }], pauseOnHover: [{
            type: Input
        }], pauseOnVisibilityChange: [{
            type: Input
        }], closeOnClick: [{
            type: Input
        }], dismissEvent: [{
            type: Output
        }], 
    /**
     * @return {?}
     */
    handleHostClick: [{
            type: HostListener,
            args: ['click']
        }], 
    /**
     * @return {?}
     */
    handleMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], 
    /**
     * @return {?}
     */
    handleMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], 
    /**
     * @return {?}
     */
    handleVisibilityChange: [{
            type: HostListener,
            args: ['document:visibilitychange']
        }], toast: [{
            type: Input
        }], iconLibrary: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    ToastifyToastComponent.prototype.autoClose;
    /** @type {?} */
    ToastifyToastComponent.prototype.hideProgressBar;
    /** @type {?} */
    ToastifyToastComponent.prototype.pauseOnHover;
    /** @type {?} */
    ToastifyToastComponent.prototype.pauseOnVisibilityChange;
    /** @type {?} */
    ToastifyToastComponent.prototype.closeOnClick;
    /** @type {?} */
    ToastifyToastComponent.prototype.toast;
    /** @type {?} */
    ToastifyToastComponent.prototype.iconLibrary;
    /** @type {?} */
    ToastifyToastComponent.prototype.dismissEvent;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastComponent.prototype.autoDismissTimeout;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastComponent.prototype.autoCloseRemaining;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastComponent.prototype.pauseTime;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastComponent.prototype.startTime;
    /** @type {?} */
    ToastifyToastComponent.prototype.ToastType;
    /** @type {?} */
    ToastifyToastComponent.prototype.running;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastComponent.prototype._cd;
    /**
     * @type {?}
     * @private
     */
    ToastifyToastComponent.prototype._zone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/angular-toastify.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AngularToastifyModule {
}
AngularToastifyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AngularToastifyModule });
AngularToastifyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AngularToastifyModule_Factory(t) { return new (t || AngularToastifyModule)(); }, imports: [[BrowserModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularToastifyModule, { declarations: function () { return [ToastifyToastComponent, ToastifyToastContainerComponent]; }, imports: function () { return [BrowserModule]; }, exports: function () { return [ToastifyToastContainerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AngularToastifyModule, [{
        type: NgModule,
        args: [{
                declarations: [ToastifyToastComponent, ToastifyToastContainerComponent],
                imports: [BrowserModule],
                exports: [ToastifyToastContainerComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: angular-toastify.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AngularToastifyModule, ToastService, ToastifyToastContainerComponent, ToastifyToastComponent as ɵa };

//# sourceMappingURL=angular-toastify.js.map